'use client';

import ActionButton from '@/components/form/ActionButton/ActionButton';
import FormText from '@/components/form/FormText/FormText';
import { swal } from '@/lib/sweetalert';
import { yup } from '@/lib/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import styles from './LoginForm.module.scss';

const formScheme = yup.object({
  email: yup.string().label('メールアドレス').required(),
  password: yup.string().label('パスワード').required(),
});

/**
 * ログインフォームの見た目のみを担当する共通UIコンポーネント
 */
function LoginForm({
  onSubmit,
  isLoading = false,
}: {
  onSubmit: (email: string, password: string) => Promise<void>;
  isLoading?: boolean;
}) {
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: { email: '', password: '' },
    resolver: yupResolver(formScheme),
  });

  const submit = async () => {
    await onSubmit(getValues('email'), getValues('password'));
  };

  const submitError = async () => {
    await swal.invalid();
  };

  return (
    <form onSubmit={handleSubmit(submit, submitError)} className={styles.form}>
      <div className={styles.formFields}>
        <FormText type='email' label='メールアドレス' name='email' control={control} isPii autocomplete='email' />
        <FormText
          type='password'
          label='パスワード'
          name='password'
          control={control}
          autocomplete='current-password'
        />
      </div>
      <div className={styles.forgotPasswordLink}>
        <Link href='/forgot-password'>パスワードをお忘れの方</Link>
      </div>
      <div className={styles.submitButton}>
        <ActionButton type='submit' dataTestId='login-button' bgColor='primary' color='white' isLoading={isLoading}>
          ログイン
        </ActionButton>
      </div>
    </form>
  );
}

export default LoginForm;
